var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H2C0.9 0 0 0.777273 0 1.72727V13.8182H2V1.72727H14V0ZM17 3.45455H6C4.9 3.45455 4 4.23182 4 5.18182V17.2727C4 18.2227 4.9 19 6 19H17C18.1 19 19 18.2227 19 17.2727V5.18182C19 4.23182 18.1 3.45455 17 3.45455ZM17 17.2727H6V5.18182H17V17.2727Z",
    fill: "#56179A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.b04c6e9abe4dda82efe6a0055571ea70.svg";
export { ForwardRef as ReactComponent };